/*eslint no-unused-vars: ["error", { "varsIgnorePattern": "[iI]gnoreLint"}]*/


export default class oldBrowser {

    constructor() {
        this.modal = document.querySelector('[data-old-browser-modal]');
        this.close_btn = document.querySelector('[data-close-old-browser-modal]')
    }

    init() {
        if (!this.modal || !this.close_btn) {
            return false;
        }

        this.setListener();
    }

    setListener() {
        this.close_btn.addEventListener('click', () => {
            const cookie = new Cookie('old_browser_information', 'accepted', 14);
            cookie.createCookie();
            this.modal.style.display = 'none';
        });
    }
}
